class Corner {
    constructor(x,y,z) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.pointX = null;
        this.pointY = null;
        this.pointZ = null;
        this.projectedX = null;
        this.projectedY = null;
        this.projectedZ = null;
    }
}

export default Corner;